import { useOutletContext } from 'react-router'
import { Container } from '@/components/ui/container'

import { ScrollArea } from '@/components/ui/scroll-area'
import { Scrollbar } from '@/components/ui/scrollbar'
import { Skeleton } from '@/components/ui/skeleton'
import { OpsVettingHero } from '@/features/ops-vetting/components/ops-vetting-atoms'
import { OpsVettingMerchFormHeader } from '@/features/ops-vetting/components/ops-vetting-merch-form-header'
import type { OpsVettingURLParams } from '@/features/ops-vetting/types'
import { ServiceVettingMerchFormSkeleton } from '@/features/service-vetting/components/service-vetting-merch-form-skeleton'
import { ServiceVettingMerchForms } from '@/features/service-vetting/components/service-vetting-merch-forms'
import { useGetService } from '@/features/service-vetting/query/use-get-service'
import { useTranslation } from '@/translations/i18n'

export const ServiceMerchandisingVettingPage = () => {
	const { urlParams } = useOutletContext<{ urlParams: OpsVettingURLParams }>()
	const { remappedData: service, isPending } = useGetService(urlParams.id)

	return (
		<ScrollArea scrollbar={<Scrollbar />}>
			{isPending || !service ? (
				<ServiceMerchandisingVettingPageSkeleton />
			) : (
				<ServiceVettingMerchForms service={service} />
			)}
		</ScrollArea>
	)
}
ServiceMerchandisingVettingPage.displayName = 'ServiceMerchandisingVettingPage'

const ServiceMerchandisingVettingPageSkeleton = () => {
	const { t } = useTranslation()
	return (
		<Container
			className='grid grid-cols-[minmax(0,1fr)] grid-rows-[auto_minmax(0,1fr)]'
			fullWidth
		>
			<OpsVettingHero align='center' fullWidth justify='space-between'>
				<h3>{t('vetting:merch.service.title')}</h3>
				<div className='flex gap-2'>
					<Skeleton height={24} width={100} />
					<Skeleton height={24} width={100} />
					<Skeleton height={24} width={100} />
				</div>
			</OpsVettingHero>
			<div className='mt-6 mb-10 flex w-full overflow-hidden rounded-2xl border border-neutral-200'>
				{[0, 1].map((index) => (
					<div className='flex-1 p-6' key={index}>
						<OpsVettingMerchFormHeader
							description={<Skeleton height={24} width={200} />}
							icon={<Skeleton height={24} width={24} />}
							title={<Skeleton height={24} width={100} />}
						/>
						<ServiceVettingMerchFormSkeleton />
					</div>
				))}
			</div>
		</Container>
	)
}
